import React from 'react';
import styled, { css } from 'styled-components';

import { Filters } from '@lt/components/icons-react/floating-panel';
import { useTranslation } from '@lt/localization';

import { FloatingPanelButton, BottomButtonText } from '../styles';
import {
  FILTERS_COUNTER_DATA_TEST_ID,
  SHOW_FILTERS_BUTTON_DATA_TEST_ID,
} from './constants';

interface IShowFiltersButton {
  count: number;
  isWhitelabel: boolean;
  isHotelOnly: boolean;
  toggleFilters: () => void;
}

const ShowFiltersButton = ({
  isWhitelabel,
  isHotelOnly,
  toggleFilters,
  count,
}: IShowFiltersButton) => {
  const { t } = useTranslation();

  return (
    <Button
      $isFirstButton={isWhitelabel || isHotelOnly}
      type="button"
      onClick={toggleFilters}
      data-testid={SHOW_FILTERS_BUTTON_DATA_TEST_ID}
    >
      <ButtonContainer>
        <div>
          {count > 0 && (
            <Counter data-testid={FILTERS_COUNTER_DATA_TEST_ID}>
              {count}
            </Counter>
          )}
          <StyledFiltersIcon />
        </div>
        <BottomButtonText>{t('hotel.filters.title')}</BottomButtonText>
      </ButtonContainer>
    </Button>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Button = styled(FloatingPanelButton)<{ $isFirstButton: boolean }>`
  box-sizing: content-box;
  ${({ $isFirstButton }) =>
    $isFirstButton
      ? css`
          border-top-left-radius: 28px;
          border-bottom-left-radius: 28px;
        `
      : css`
          border-left: 1px solid #f1f1f1;
        `}

  border-right: 1px solid #f1f1f1;
`;

const Counter = styled.span`
  position: absolute;
  transform: translate(36%, 38%);
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  background-color: #f8e71c;
  color: #17181a;
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
`;

const StyledFiltersIcon = styled(Filters)`
  width: 24px;
  height: 24px;
`;

export default ShowFiltersButton;
